// extracted by mini-css-extract-plugin
export default {"app":"Logo_app__KJ2Fa"};